export const MAXIMUM_MESSAGE_LENGTH = 500;